import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useUnitGet } from "hooks/citajteo/dl_unit/useUnitGet";
import { useUnitUpdate } from "hooks/citajteo/dl_unit/useUnitUpdate";
import { QUERY_KEYS } from "constant/react_query";
import toast from "react-hot-toast";
import UnitForm, {
  UnitFormState,
} from "components/admin/common/dl_unit/UnitForm/UnitForm";
import UnitEditNav from "components/admin/common/dl_unit/nav/UnitEditNav";
import { EMPTY_FORM } from "constant/dl_unit/dl_unit_form.constant";

const buildFormFromUnit = (unit: any): UnitFormState => ({
  slug: unit.slug ?? "",
  uType: unit.uType ?? "",
  uDate: unit.uDate ?? null,
  num: unit.num !== undefined && unit.num !== null ? String(unit.num) : "",
  fVals: unit.fVals ?? {},
});

const DlUnitEdit: React.FC = () => {
  const navigate = useNavigate();
  const { itemId = "" } = useParams<{ itemId: string }>();
  const [searchParams] = useSearchParams();
  const searchBy = searchParams.get("searchBy") ?? "id";
  const unit = useUnitGet(itemId, searchBy);
  const { unitUpdateMutate } = useUnitUpdate({
    invalidateKeysArray: [
      [QUERY_KEYS.CITAJTEO_DL_UNIT_SEARCH],
      [QUERY_KEYS.CITAJTEO_DL_UNIT_GET, unit?.id as string],
    ],
  });
  const {
    control,
    handleSubmit: handleFormSubmit,
    reset,
  } = useForm<UnitFormState>({ defaultValues: EMPTY_FORM });
  const [errorText, setErrorText] = useState("");

  useEffect(() => {
    if (unit) {
      reset(buildFormFromUnit(unit));
    }
  }, [reset, unit]);

  const handleSubmit = (form: UnitFormState) => {
    setErrorText("");

    const trimmedSlug = form.slug.trim();
    if (trimmedSlug === "") {
      setErrorText("Slug ne sme biti prazan.");
      return;
    }

    const parsedNum = Number(form.num);
    if (Number.isNaN(parsedNum)) {
      setErrorText("Broj mora biti numerička vrednost.");
      return;
    }

    unitUpdateMutate(
      {
        id: unit?.id as string,
        updatePayload: {
          slug: trimmedSlug,
          uType: form.uType.trim(),
          uDate: form.uDate ?? null,
          num: parsedNum,
          fVals: form.fVals,
        },
      },
      {
        onSuccess: () => {
          toast.success("Uspešno ažuriranje jedinice.");
          navigate(`/admin-dashboard/dl-unit-edit/${unit?.id}`);
        },
        onError: (error) => {
          console.error("Error updating unit:", error);
          toast.error("Greška prilikom ažuriranja jedinice.");
        },
      },
    );
  };

  const handleReset = () => {
    if (unit) {
      reset(buildFormFromUnit(unit));
    } else {
      reset(EMPTY_FORM);
    }
    setErrorText("");
  };

  if (!unit) {
    return <Div>Učitavanje jedinice...</Div>;
  }

  return (
    <Div>
      <UnitEditNav unit={unit} />
      <UnitForm
        control={control}
        errorText={errorText}
        onSubmit={handleFormSubmit(handleSubmit)}
        onReset={handleReset}
        unit={unit}
      />
    </Div>
  );
};

export default DlUnitEdit;

const Div = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`;
